import Config from "@/const/Config";
import { BaseOptionWithoutCode } from "@/types/Option";
import { BaseApi } from "@/api/BaseApi";
import { Syozoku } from "@/types/Syozoku";

export class MstSyozokuApi extends BaseApi {
  public async getAll(): Promise<Syozoku[]> {
    try {
      const res = await this.post<Syozoku[]>(Config.API_URL + '/master/syozoku/all', null);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 全ての所属会社の部課を取得します（オプション値）
   */
  public async getAllOptions(): Promise<BaseOptionWithoutCode[]> {
    try {
      const res = await this.post<BaseOptionWithoutCode[]>(Config.API_URL + '/master/syozoku/options/all', null);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

}
